import { DataView24, Edit24 } from "@carbon/icons-react";
import {
  Button,
  ButtonSet,
  Column,
  Form,
  FormGroup,
  Loading,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  basicApplicationSchema,
  companySchema,
} from "../../services/SchemaService";
import SubmitButton from "../../components/Buttons/SubmitButton";
import { toast } from "react-toastify";
import TraineeProfileForm from "./TraineeProfileForm";

const TraineeProfilePage = () => {
  const { user, isCompetitor } = useContext(AuthContext);
  const [application, setApplication] = useState(null);
  const [businessPlan, setBusinessPlan] = useState(null);
  const [company, setCompany] = useState(null);
  const [disabled, setDisabled] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(companySchema),
    mode: "onBlur",
  });

  const navigate = useNavigate();

  const loadApplication = async () => {
    try {
      const response = await http.get(`/applications/phone/${user.username}`);
      setApplication(response.data);
    } catch (error) {}
  };

  const loadBusinessPlan = async () => {
    try {
      const response = await http.get(`/business-plan/nur/NUR${user.username}`);
      setBusinessPlan(response.data);
    } catch (error) {}
  };

  const loadCompany = async () => {
    try {
      const response = await http.get(
        `/internships/companies/nur/NUR${user.username}`
      );
      setCompany(response.data);
      reset(response.data);
    } catch (error) {}
  };

  const handlCreate = () => {
    navigate("../registar-candidatura", { replace: true });
  };
  const handlUpdate = () => {
    navigate("../actualizar-candidatura/" + application.uuid, {
      replace: true,
    });
  };

  const onSubmit = async (data) => {
    try {
      console.log(company);
      const response =
        company == null
          ? await http.post("/internships/companies", data)
          : await http.put("/internships/companies", data);
      toast.success("Empresa actualizada com sucesso");
      loadCompany();
      setDisabled(true);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {}, []);

  return (
    <Card title={"Olá " + user.firstName + " " + user.lastName}>
      <TraineeProfileForm />
    </Card>
  );
};

export default TraineeProfilePage;
